export const profile = {
  'Top artists this month': 'Artistas mais ouvidos este mês',
  'Top tracks this month': 'Músicas mais ouvidas este mês',
  Songs: 'Músicas',
  'Only visible to you': 'Visível apenas para você',
  'Public playlists': 'Playlists públicas',
  Profile: 'Perfil',
  Followers: 'Seguidores',
};
